import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CheckStorageService } from '../../../services/check-storage.service';

@Component({
  selector: 'lib-inspection-offcanvas',
  templateUrl: './inspection-offcanvas.component.html',
  styleUrls: ['./inspection-offcanvas.component.scss']
})
export class InspectionOffcanvasComponent implements OnChanges {
  @Input() additionalInfo!: string;
  @Input() isCollapsed = true;
  @Input() additionalInfoData!: { informationSection: string, formalBasics: string };
  @Output() childData = new EventEmitter();

  public config = {
    toolbar: [],
    disableResizeEditor: true,
  };
  
  constructor( public checkStorageService: CheckStorageService) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['additionalInfo'] && changes['additionalInfo'].currentValue) {
      this.additionalInfo = changes['additionalInfo'].currentValue;
      this.additionalInfo = this.additionalInfo.replaceAll('<h2>', '<h2 style="font-family: Panton; font-size: 22px !important; font-weight: bold; line-height: 29px;">');
      this.additionalInfo = this.additionalInfo.replaceAll('<p>', '<p style="font-family: Roboto; font-size: 14px !important; font-weight: normal; line-height: 22px;">');
    }

    if(changes['additionalInfoData'] && changes['additionalInfoData'].currentValue) {
      this.additionalInfoData = changes['additionalInfoData'].currentValue;
      if (this.additionalInfoData.informationSection && this.additionalInfoData.informationSection.length > 0) {
        this.additionalInfoData.informationSection = `<p style="font-family: Roboto; font-size: 14px !important; font-weight: normal; line-height: 22px;">${this.additionalInfoData.informationSection.replaceAll('\n', '<br>')}</p>`;
      }

      if (this.additionalInfoData.formalBasics && this.additionalInfoData.formalBasics.length > 0) {
        this.additionalInfoData.formalBasics = `<p style="font-family: Roboto; font-size: 14px !important; font-weight: normal; line-height: 22px;">${this.additionalInfoData.formalBasics.replaceAll('\n', '<br>')}</p>`;
      }
    }
  }

  closeInspection() {
    this.childData.emit({key: 'close'});
  }
}
